/*
 * @Author: liyifan
 * @Date: 2024-06-19 16:45:34
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-08-30 16:08:27
 * @description: 首页-用户故事
 */
import { isMobile  } from '@utils/index.js'
export class StoriesSwiper {
    constructor() {
        this.init();
    }
    init() {
        new Swiper(".stories-swiper", {
            spaceBetween: 32,
            slidesPerView: 1.2,
            slideToClickedSlide: true,
            autoplay: false,
            freeMode: !isMobile(),
            speed: isMobile() ? 600 : 3000,
            loop: isMobile(),
            breakpoints: {
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 5,
                },
            },
            pagination: {
                el: ".stories-pagination",
            },
        });
    }
}
